import { Injectable } from '@angular/core';
import { RmsBasicCrudService } from '../../components/rms-basic-crud.service';
import { HttpClient } from '@angular/common/http';
import { ExceptionService, PaginatedList, UtilsService } from '../../../xform-compat';
import { Observable } from 'rxjs';
import { CompanyIdentifier, CompanyIdentifierType } from '../../../shared/models';
import { CONFIG } from '../../../config';

@Injectable({
  providedIn: 'root'
})
export class CompanyIdentifiersService extends RmsBasicCrudService<any> {

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /**
   * Gets the list of available identifier types
   * @param params
   * @returns {Observable<PaginatedList<CompanyIdentifierType>>}
   */
  public getCompanyIdentifierType (params?: any): Observable<PaginatedList<CompanyIdentifierType>> {
    return this.getData(`${CONFIG.apiUrl}/rms/companyidentifiertypes`, params);
  }

  /**
   * Gets the list of identifiers for a company
   * @param {number} companyId
   * @param params
   * @returns {Observable<PaginatedList<CompanyIdentifier>>}
   */
  public getCompanyIdentifiers (companyId: number, params?: any): Observable<PaginatedList<CompanyIdentifier>> {
    return this.getData(`${CONFIG.apiUrl}/rms/companies/${companyId}/identifiers`, params);
  }

  /**
   * Updates the current identifiers of the company
   * @param {number} companyId
   * @param {number} identifierId
   * @param body
   * @returns {Observable<CompanyIdentifier>}
   */
  public updateCompanyIdentifier (companyId: number, identifierId: number, body: any): Observable<CompanyIdentifier> {
    return this.updateData(`${CONFIG.apiUrl}/rms/companies/${companyId}/identifiers/${identifierId}/onboard`, body);
  }

  /**
   * Deletes a company identifier
   * @param {number} companyId
   * @param {number} identifierId
   * @returns {Observable<CompanyIdentifier>}
   */
  public deleteCompanyIdentifier (companyId: number, identifierId: number): Observable<CompanyIdentifier> {
    return this.deleteData(`${CONFIG.apiUrl}/rms/companies/${companyId}/identifiers/${identifierId}`);
  }

  /**
   * Creates a new identifier
   * @param {number} companyId
   * @param body
   * @returns {Observable<CompanyIdentifier>}
   */
  public createCompanyIdentifier (companyId: number, body: any): Observable<CompanyIdentifier> {
    return this.saveData(`${CONFIG.apiUrl}/rms/companies/${companyId}/identifiers/onboard`, body);
  }

}
